@if (loaded) {
  <div class="modal-content">
    <div class="modal-header bg-tertiary">
      <h6 class="modal-title fw-bold">{{ title }}</h6>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <div class="table-responsive">
        <table class="table" style="white-space: unset;">
          <thead>
            <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
              <th tableSorterHeader="id">ID</th>
              <th tableSorterHeader="createdAt">Date</th>
              <th>User</th>
              <th>Action</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            @for (userEvent of userEvents; track userEvent) {
              <tr>
                <td>{{ userEvent.id }}</td>
                <td>{{ userEvent.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td>{{ userEvent.user }}</td>
                <td>{{ userEvent.action }}</td>
                <td>
                  <button type="button" class="btn btn-primary" (click)="toggleData(userEvent)"
                    [disabled]="!hasData(userEvent)"><i class="bi bi-eye-fill"></i></button>
                  </td>
                </tr>
                @if (isExpandedData(userEvent)) {
                  <tr>
                    <td colspan="5">
                      <div class="data">
                        <pre>{{ getData(userEvent) }}</pre>
                      </div>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
        <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
      </div>
    </div>
  }
